export function formatDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
}

/**
 * "Nicole Charlotte Marie Louise Le Déc de Rencourt" -> "Nicole Le Déc de Rencourt"
 *
 * This family's records carry full baptismal names, which are wonderful in the
 * tree and overwhelming as a byline over a snapshot. First given name plus the
 * surname, keeping any particle attached to it — dropping "de" or "Le" would be
 * getting somebody's name wrong, which is worse than a long byline.
 */
export function shortName(full) {
  if (!full) return "A cousin";
  const parts = String(full).trim().split(/\s+/);
  if (parts.length <= 2) return full;
  const PARTICLES = ["de", "du", "des", "van", "von", "la", "le", "di", "da"];
  let i = parts.length - 1;
  while (i > 1 && PARTICLES.includes(parts[i - 1].toLowerCase())) i -= 1;
  return [parts[0], ...parts.slice(i)].join(" ");
}
